import { Controller } from "@hotwired/stimulus"

// Opens an owner's properties inside their own row on the Atualização de Base
// table. Wraps one owner row plus its property rows; a row with a single
// property has no body target and the toggle is a no-op.
export default class extends Controller {
  static targets = ["body", "chevron"]

  toggle(event) {
    // The row itself is the click surface, so the links and buttons sitting on
    // it — ver conversa, marcar como feito — must not also fold it.
    if (event.target.closest("a, button, input, select")) return
    if (!this.hasBodyTarget) return

    const collapsed = this.bodyTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-90", !collapsed)
  }
}
